import React from 'lib/react';
import {
  EVPaper,
  EVAlert,
  EVGrid,
  EVTypography,
  EVButton,
  makeStyles,
} from 'lib/components';
import { SUPPORT_ROUTE } from 'constants/RouteConstants';
import { Link } from 'lib/router';
import { useTranslation } from 'lib/translation';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
  orderResolvedContainer: {
    display: 'flex',
    flex: 1,
    flexDirection: 'column',
    padding: '16px 24px',
    width: '100%',
    '@media(max-width: 1024px)': {
      padding: '0px',
    },
  },
  orderResolvedPaper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: '24px',
    gap: '16px',
    flex: 1,
    '@media(min-width: 640px)': { alignItems: 'flex-start' },
  },
  alertContainer: {
    backgroundColor: theme.evPalette.mango[100],
    width: '100%',
  },
  orderResolvedMessage: {
    fontWeight: 400,
    fontSize: '18px',
    lineHeight: '27px',
    color: theme.evPalette.charcoal[900],
    '& a': {
      color: theme.evPalette.ocean[700],
      textDecoration: 'none',
    },
  },
  warningAlertIcon: { '& svg': { color: theme.evPalette.mango[700] } },
}));

function OrderResolvedScreen(props) {
  const { t } = useTranslation();
  const classes = useStyles();

  const { backToOrderHistoryUrl } = props;

  return (
    <EVGrid className={classes.orderResolvedContainer}>
      <EVPaper elevation={0} className={classes.orderResolvedPaper}>
        <EVAlert
          severity="warning"
          className={classes.alertContainer}
          classes={{ message: classes.orderResolvedMessage, icon: classes.warningAlertIcon }}
        >
          <EVTypography>
            {t('address_verification__order_already_resolved_msg')}
            <Link to={SUPPORT_ROUTE}>{t('order_history__actions__customer_service_link')}</Link>
            .
          </EVTypography>
        </EVAlert>
        <EVButton
          variant="contained"
          color="primary"
          component={Link}
          to={backToOrderHistoryUrl}
          id="back-to-order-history-btn"
        >
          {t('report_details__back_to_order_history')}
        </EVButton>
      </EVPaper>
    </EVGrid>
  );
}

OrderResolvedScreen.propTypes = {
  backToOrderHistoryUrl: PropTypes.string.isRequired,
};

export default OrderResolvedScreen;
